import { YANDEX_METRIKA_ID } from '@/config/metrika'

const COUNTER_ID = Number(YANDEX_METRIKA_ID)
const CONSENT_KEY = 'analytics_consent'
let initialized = false

export const getAnalyticsConsent = () => localStorage.getItem(CONSENT_KEY)
export const isMetrikaConfigured = () => Number.isInteger(COUNTER_ID) && COUNTER_ID > 0

export const initMetrika = () => {
  if (initialized || !isMetrikaConfigured() || getAnalyticsConsent() !== 'accepted') return
  window.ym = window.ym || function () { (window.ym.a = window.ym.a || []).push(arguments) }
  window.ym.l = Date.now()

  if (!document.querySelector('script[data-yandex-metrika]')) {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://mc.yandex.ru/metrika/tag.js'
    script.dataset.yandexMetrika = 'true'
    document.head.appendChild(script)
  }

  window.ym(COUNTER_ID, 'init', {
    defer: true,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: false,
  })
  initialized = true
}

export const setAnalyticsConsent = (value) => {
  localStorage.setItem(CONSENT_KEY, value ? 'accepted' : 'declined')
  if (value) initMetrika()
}

const getSafePageUrl = (route) => {
  const path = route?.path || window.location.pathname || '/'
  return `${window.location.origin}${path}`
}

export const trackPageView = (to, from) => {
  if (!initialized || !window.ym) return
  window.ym(COUNTER_ID, 'hit', getSafePageUrl(to), {
    title: document.title,
    referer: from?.path ? `${window.location.origin}${from.path}` : undefined,
  })
}

export const trackGoal = (goal, params = {}) => {
  if (initialized && window.ym) window.ym(COUNTER_ID, 'reachGoal', goal, params)
}
